export default __webpack_public_path__ + "static/media/twitterIconCircle.da776bdc.svg";